// extracted by mini-css-extract-plugin
export var BODY = "Typography-module--BODY--CfNoU";
export var BODY__newLayout = "Typography-module--BODY__newLayout--1eJfE";
export var BUTTON = "Typography-module--BUTTON--fHqAZ";
export var BUTTON__newLayout = "Typography-module--BUTTON__newLayout--cJ0Qj";
export var CAPTION = "Typography-module--CAPTION--zkehb";
export var CAPTION__newLayout = "Typography-module--CAPTION__newLayout--iQVSo";
export var DESCRIPTION = "Typography-module--DESCRIPTION--U0qfm";
export var DESCRIPTION__newLayout = "Typography-module--DESCRIPTION__newLayout--MQrjr";
export var FOOTER = "Typography-module--FOOTER--VhVEZ";
export var FOOTERBOLD = "Typography-module--FOOTERBOLD--Ju98q";
export var FOOTER__newLayout = "Typography-module--FOOTER__newLayout--EbgCE";
export var HEADER1 = "Typography-module--HEADER1--j-H28";
export var HEADER1__newLayout = "Typography-module--HEADER1__newLayout--YTRlZ";
export var HEADER2 = "Typography-module--HEADER2--gy6K6";
export var HEADER2__newLayout = "Typography-module--HEADER2__newLayout--z7Ju4";
export var HEADER3 = "Typography-module--HEADER3--ExSEw";
export var HEADER3__newLayout = "Typography-module--HEADER3__newLayout--GUEjI";
export var HEADER4 = "Typography-module--HEADER4--qj7+G";
export var HEADER4__newLayout = "Typography-module--HEADER4__newLayout--zKwcR";
export var HERO = "Typography-module--HERO--DEKuV";
export var HERO__newLayout = "Typography-module--HERO__newLayout--rLBt2";
export var QUOTE = "Typography-module--QUOTE--bqLMI";
export var SUBHEADERDESC = "Typography-module--SUBHEADERDESC--9MRG2";
export var SUBHEADERDESCBOLD = "Typography-module--SUBHEADERDESCBOLD--b4kWB";
export var SUBHEADERDESC__newLayout = "Typography-module--SUBHEADERDESC__newLayout--h2OQI";
export var SUBTITLE = "Typography-module--SUBTITLE--Pn33X";
export var SUBTITLE__newLayout = "Typography-module--SUBTITLE__newLayout--tcTAk";
export var center = "Typography-module--center--5Bs7K";
export var limitWidthOnLargeScreens = "Typography-module--limitWidthOnLargeScreens--0vwZo";